import { Pipe, PipeTransform } from '@angular/core';
import { getId } from '../helpers/get-id.helper';

@Pipe({
  name: 'getId',
})
export class GetIdPipe implements PipeTransform {
  transform(entity: string | { id?: string; longId?: string; _id?: string }): string {
    return getId(entity);
  }
}
